var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "video-container"
  }, [_c("div", {
    staticStyle: {
      width: "100%",
      height: "100%"
    },
    attrs: {
      id: "valveVideogj".concat(_vm.idName || _vm.id)
    }
  })]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };